// Copyright (c) 2020 embyt GmbH. All rights reserved.

import * as React from "react";
import { connect } from "react-redux";
import { FormattedDate } from "react-intl";

import { IAction } from "actions";
import { IState } from "states/states";
import { getBrowserTimezoneOffset } from "utils";

interface IFormattedDateExtProps {
  valueMs?: number; // in ms
  valueS?: number; // in s
  longFormat?: boolean;
  doZeroPadding?: boolean;
  noDay?: boolean;
}

interface IFormattedDateProps {
  adjTimestamp: number | undefined;
}

const mapStateToProps = (state: IState, ownProps: IFormattedDateExtProps) => {
  let adjTimestamp;
  const ms = ownProps.valueMs ?? (ownProps.valueS ? 1000 * ownProps.valueS : undefined);
  if (ms) {
    // the timestamp will always be displayed in browser local time by the react FormattedDate component
    // thus, we need to fake the timestamp with the offset of the device compared to local timezone
    // derive offset in seconds
    const offset = state.site.tzOffset ? state.site.tzOffset + getBrowserTimezoneOffset() : 0;
    adjTimestamp = ms + 1000 * offset;
  }
  const props: IFormattedDateProps = {
    adjTimestamp,
  };
  return props;
};

interface IFormattedDateDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IFormattedDateDispatch = {};
  return dispatchProps;
};

class FormattedDateComponent extends React.Component<
  IFormattedDateProps & IFormattedDateExtProps & IFormattedDateDispatch
> {
  public render() {
    if (this.props.adjTimestamp) {
      const timestamp = new Date(this.props.adjTimestamp);
      return (
        <FormattedDate
          day={!this.props.noDay ? (this.props.doZeroPadding ? "2-digit" : "numeric") : undefined}
          month={this.props.longFormat ? "long" : this.props.doZeroPadding ? "2-digit" : "numeric"}
          year="numeric"
          value={timestamp}
        />
      );
    } else {
      return <></>;
    }
  }
}

const MyFormattedDate = connect(mapStateToProps, mapDispatchToProps)(FormattedDateComponent);

export default MyFormattedDate;
